const toObject = (prev, [key, value]) => ({
    ...prev,
    [key]: value
});

const getMetricsForMetricsIndex = (metricsByIndex, index) => metricsByIndex.map(({ metrics }) => metrics[index]);

/**
 * Aggregates metrics into an Object with the following format:
 * {
 *   sumDistance: [0, 1, ...]
 *   sumDuration: [0, 1, ...]
 *   ...
 * }
 * Adapted from Multisport Edit Utils
 */
export const aggregateMetrics = (activityMetrics) => {
    if (!activityMetrics) return null;
    const { metricDescriptors, activityDetailMetrics } = activityMetrics;

    if (!metricDescriptors) return null;
    if (!activityDetailMetrics || activityDetailMetrics.length === 0) return null;

    const metricsByKey = metricDescriptors
        .map((metricDesc) => {
            const { metricsIndex, key } = metricDesc;
            const metricsArray = getMetricsForMetricsIndex(activityDetailMetrics, metricsIndex);
            const res = [key, metricsArray];
            return res;
        })
        .reduce(toObject, {});

    return metricsByKey;
};

export const DISTANCE_MARKERS = {
    RUNS: 'runs',
    TIMING_GATES: 'timingGates',
    SWIM_STRAIGHTNESS: 'swimStraightness',
    NONE: 'none'
};

export const ACTIVITY_HIGHLIGHT_MARKERS = {
    JUMPS: 'jumps',
    CLIMBS: 'climbs'
};

export const getSelectedMapLayerValues = (mapLayers = []) => {
    return mapLayers.filter((layer) => layer.selected).map((layer) => layer.value);
};

export const getDefaultSelectedDistanceMarkers = (distanceMarkers = []) => {
    return distanceMarkers.filter((marker) => marker?.selected).map((marker) => marker.value);
};

export const getSelectedActivityHighlightMarkers = (markers = []) => {
    return markers.filter((marker) => marker.selected).map((marker) => marker.value);
};

export const toggleChangeForSelectedMarkers = (markers, selectedMarkers) => {
    markers?.forEach(({ value, toggle }) => {
        if (typeof toggle === 'function') {
            toggle(selectedMarkers.includes(value));
        }
    });
};

export const MAP_SETTINGS_ACTIVITIES_KEY = 'Map.Setting.Activities';

export const wrapRepCountingActivity = (activity) => {
    if (activity && activity.exerciseSets) {
        const { exerciseSets } = activity;

        const getTotalTime = () => {
            return exerciseSets.reduce((acc, set) => {
                return acc + set.duration;
            }, 0);
        };

        const getWorkTime = () => {
            return exerciseSets.reduce((acc, set) => {
                if (set.exerciseType !== 'REST') {
                    return acc + set.duration;
                }
                return acc;
            }, 0);
        };

        const getActiveSetCount = () => {
            return exerciseSets.reduce((acc, set) => {
                if (set.exerciseType !== 'REST') {
                    return acc + 1;
                }
                return acc;
            }, 0);
        };

        const getTotalRepCount = () => {
            return exerciseSets.reduce((acc, set) => {
                if (set.exerciseType !== 'REST') {
                    return acc + set.repetitionCount;
                }
                return acc;
            }, 0);
        };

        return {
            ...activity,
            getTotalTime,
            getWorkTime,
            getActiveSetCount,
            getTotalRepCount
        };
    }
    return activity;
};
